<template>
	<div>
		<formInput
			:value="value"
			@input="handleInput"
			class="showable"
			:id="id"
			:hasError=hasError
			:overrideErrorText = overrideErrorText
			:enterHandler="enterHandler"
			:maxLength=32
			:placeholder="placeholder"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
			@keydown="checkCapsLock"
			:show-pass="showPass"
			:input-ref="inputRef">

			<div
				class="info-icons">
				<svgIcon v-if="capsLock" iconHolderClass="caps-lock" iconId="icon-caps-lock"/>
				<div @click="toggleShowPass">
					<svgIcon iconHolderClass="toggle-show-pass" :iconId="`icon-eye-${showPass ? 'close' : 'open'}`"/>
				</div>
			</div>
		</formInput>
	</div>
</template>

<script>
import formInput from './form-input';
import svgIcon from '../common/icon-svg';

export default {
	name: 'formPassword',
	introduction: 'Vuejs password input form component',
	components: {
		formInput,
		svgIcon
	},
	props: {
		id: {
			type: String,
			value: null,
			note: 'Set element id'
		},
		enterHandler: {
			type: Function,
			value: null,
			note: 'Keyboard enter key handler'
		},
		value: {
			type: String,
			value: null,
			note: 'Assign input value'
		},
		overrideErrorText: {
			type: String,
			default: null,
			note: 'Replace error Text'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Show error text'
		},
		inputRef: {
			type: String,
			default: 'passwordRef',
		},
		placeholder: {
			type: String,
			default: '',
			note: 'Placeholder text inside form'
		},
	},
	data() {
		return {
			showPass: false,
			internalValueCopy: '',
			capsLock: false,
		};
	},
	methods: {
		toggleShowPass() {
			this.showPass = !this.showPass;
			this.$emit('setPasswordVisibility', this.showPass);
		},
		handleInput(value) {
			this.internalValueCopy = value;
			this.$emit('input', value);
		},
		checkCapsLock(e) {
			this.capsLock = e.getModifierState('CapsLock');
		},
	},
};
</script>

<style lang="less">
	input::-ms-reveal,
	input::-ms-clear {
		display: none !important;
	}

	.info-icons {
		position: relative;

		.toggle-show-pass {
			width: 20px;
			height: 50px;
			position: absolute;
			top: -50px;
			right: 12px;
			cursor: pointer;
			opacity: .2;

			&:hover {
				opacity: .5;
			}
			&:focus {
				opacity: .4;
			}
		}
		.caps-lock {
			width: 20px;
			height: 50px;
			position: absolute;
			top: -50px;
			right: 45px;
			opacity: .2;
		}
	}
</style>
